import React, { useState } from "react";
import { StarInput } from "./Stars";
import { apiRequest, errorMessage } from "../../api";

// Rate the other side of a completed job (1-5 stars + an optional comment). Calls onDone() when saved.
export default function ReviewForm({ jobId, who, onDone, onCancel }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return setError("Choose a star rating first.");
    setBusy(true);
    setError("");
    const { ok, data } = await apiRequest(`/core/cowork/jobs/${jobId}/review/`, { method: "POST", auth: true, body: { rating, comment } });
    setBusy(false);
    if (!ok) return setError(errorMessage(data));
    onDone();
  };

  return (
    <form onSubmit={submit} className="mt-4 rounded-lg bg-white/5 border border-navy-border p-4 space-y-3">
      <p className="text-sm font-semibold">How was your experience with {who}?</p>
      <StarInput value={rating} onChange={setRating} />
      <textarea
        rows={3}
        maxLength={500}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Share a few words about the work and communication (optional)"
        className="w-full px-3 py-2 rounded-lg bg-white/5 border border-navy-border text-white text-sm focus:outline-none focus:border-accent-light"
      />
      {error && <p className="text-sm text-red-400">{error}</p>}
      <div className="flex gap-2">
        <button disabled={busy} className="px-5 py-2 rounded-full bg-brand-gradient text-sm font-semibold disabled:opacity-60">{busy ? "Saving..." : "Submit Review"}</button>
        <button type="button" onClick={onCancel} className="px-5 py-2 rounded-full border border-navy-border text-sm text-gray-300 hover:text-white">Cancel</button>
      </div>
    </form>
  );
}
